import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import FeedbackModal from "./FeedbackModal";
import { Mail, MessageCircle, LifeBuoy } from "lucide-react";

const SUPPORT_EMAIL = "kaviourapalvelut@gmail.com";

export default function Footer() {
  const { t } = useI18n();
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-[#E6E2D8] bg-[#F4F1E9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-4 gap-10">
        {/* Brand + support */}
        <div className="md:col-span-2 max-w-md">
          <div className="font-serif-display text-3xl text-[#143122]">Kavioura</div>
          <p className="mt-3 text-sm text-[#1A1F1C]/70">{t("footer_note")}</p>

          <div className="mt-6 space-y-3 text-sm">
            <button
              type="button"
              data-testid="footer-feedback-btn"
              onClick={() => setFeedbackOpen(true)}
              className="inline-flex items-center gap-2 text-[#143122] hover:underline"
            >
              <MessageCircle size={14} strokeWidth={1.75} />
              {t("leave_feedback")}
            </button>

            <div className="text-[#1A1F1C]/70">
              <div className="flex items-center gap-2">
                <LifeBuoy size={14} strokeWidth={1.75} className="text-[#143122]" />
                <span className="font-medium text-[#1A1F1C]">{t("urgent_help")}</span>
              </div>
              <a
                data-testid="footer-support-email"
                href={`mailto:${SUPPORT_EMAIL}?subject=Kavioura%20support`}
                className="mt-1 inline-flex items-center gap-2 text-[#143122] hover:underline"
              >
                <Mail size={14} strokeWidth={1.75} />
                {SUPPORT_EMAIL}
              </a>
            </div>

            <div className="text-xs text-[#1A1F1C]/55 pt-1">
              {t("response_time")}
            </div>
          </div>
        </div>

        {/* Marketplace */}
        <div className="text-sm text-[#1A1F1C]/70 space-y-2">
          <div className="overline text-[#143122]">{t("marketplace_label")}</div>
          <div>{t("nav_horses")}</div>
          <div>{t("tack")}</div>
          <div>{t("boarding")}</div>
          <div>{t("nav_jobs")}</div>
          <div>{t("nav_services")}</div>
        </div>

        {/* Company */}
        <div className="text-sm text-[#1A1F1C]/70 space-y-2">
          <div className="overline text-[#143122]">Kavioura</div>
          <div>© {new Date().getFullYear()} Kavioura</div>
          <div>Helsinki · Stockholm</div>
          <div className="pt-2">
            <button
              type="button"
              data-testid="footer-report-btn"
              onClick={() => setFeedbackOpen(true)}
              className="text-[#143122] hover:underline"
            >
              {t("report_issue")}
            </button>
          </div>
          <div className="pt-1">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="text-[#143122] hover:underline"
            >
              {t("privacy_policy")}
            </Link>
          </div>
        </div>
      </div>

      <FeedbackModal open={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
    </footer>
  );
}
